export const SOLANA_SIGNER_LANE_POLL_INTERVAL_MS = 5_000
export const SOLANA_SIGNER_RPC_HEALTH_POLL_INTERVAL_MS = 20_000

export function resolveSolanaSignerLaneRefetchInterval(
  isActive: boolean
): typeof SOLANA_SIGNER_LANE_POLL_INTERVAL_MS | false {
  return isActive ? SOLANA_SIGNER_LANE_POLL_INTERVAL_MS : false
}

export function resolveSolanaSignerRpcHealthRefetchInterval(
  isActive: boolean
): typeof SOLANA_SIGNER_RPC_HEALTH_POLL_INTERVAL_MS | false {
  return isActive ? SOLANA_SIGNER_RPC_HEALTH_POLL_INTERVAL_MS : false
}
